import { useEffect, useRef, useState } from 'react'

import TextInput from '../../../components/ReusableComponents/ManageHotel/TextInput/index'
import styles from './ZipSearchRow.module.scss'

const ZipSearchRow = ({ handleSearch, loading, initialZipCode }) => {
  const [zipCode, setZipCode] = useState(initialZipCode)
  const [submitDisabled, setSubmitDisabled] = useState(true)
  const isInitialZipSearchDone = useRef(false)

  useEffect(() => {
    if (!loading && zipCode && zipCode.length === 5) {
      setSubmitDisabled(false)
    } else {
      setSubmitDisabled(true)
    }
  }, [loading, zipCode])

  useEffect(() => {
    if (isInitialZipSearchDone.current) return
    handleSearch(null, null, initialZipCode)
    isInitialZipSearchDone.current = true
  }, [handleSearch, initialZipCode])

  function cleanUpNumber(number) {
    return number
      .toLowerCase()
      .trim()
      .replace(/[^0-9|*]+$/g, '')
  }

  function handleSubmit(e) {
    e.preventDefault()
    if (!submitDisabled) {
      handleSearch(null, null, zipCode)
    }
  }

  return (
    <form className={styles.container} onSubmit={handleSubmit}>
      <TextInput
        value={zipCode}
        onChange={e => setZipCode(cleanUpNumber(e.target.value))}
        label="Zip Code"
        width={220}
      />
      <button disabled={submitDisabled} className={styles.primaryButton}>
        {loading ? 'Loading' : 'Search'}
      </button>
      <span>
        Input a <strong>5-digit</strong> ZIP code to begin your search.
      </span>
    </form>
  )
}
export default ZipSearchRow
